"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-type-alias */
exports.__esModule = true;
//# sourceMappingURL=guards.js.map